module.exports = __webpack_public_path__ + "media/format-selector/hybrid_event@1x-57b7ad04.png";